import { serialize } from '@/@core/libs/serialize/util'
import Http from '@/services/http'

// LIST ALL TESTIMONIALS
export const testimonialList = (params = '') => Http.get(`/user-testimonials${serialize(params)}`)
export const testimonialCreate = (params = '') => Http.post('/user-testimonials', params)
export const testimonialByID = (params = '') => Http.get(`/user-testimonials/${params}`)
export const testimonialUpdate = (params = '') => Http.put(`/user-testimonials/${params.id}`, params)
export const testimonialDestroy = (params = '') => Http.delete(`/user-testimonials/${params.id}`)
export const testimonialRequestPhoto = (id) => Http.post(`/user-testimonials/${id}/request-photo`)
